// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__ZntQt","row":"default_row__EJMe3"};